import { combineReducers } from "redux";
import { actions } from "../types";
import { createApiReducer } from "./createApiReducer";

export default combineReducers({
    account: createApiReducer(actions.createAuthedAccount)  
  })